import { SystemOptionType } from 'data/types';
import { formatCoverageScore } from 'utils/coverage-score-format';
import {
  CoverageShortfall,
  getCoverageShortfalls
} from 'utils/coverage-shortfalls';
import { ductedPercentLabel } from 'utils/ducted-coverage';

export type ZoneCoverageCell = {
  value: string;
  shortfalls: CoverageShortfall[];
};

export function ductedZoneCoverageCell(
  percent: number | null
): ZoneCoverageCell {
  return { value: ductedPercentLabel(percent), shortfalls: [] };
}

export function ductlessZoneCoverageCell(
  type: 'heating' | 'cooling',
  score: number | null,
  condenserCoverage: SystemOptionType['condenserCoverage']
): ZoneCoverageCell {
  return {
    value: formatCoverageScore(score),
    shortfalls: getCoverageShortfalls(type, score, condenserCoverage)
  };
}
